import {HttpClient} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {environment} from '@environments/environment';
import {Observable} from 'rxjs';
import {ProcessoSei} from '@core/models/processo-sei';

/** Notificações com processo do SEI (só para quem tem a integração com o SEI liberada). */
@Injectable({providedIn: 'root'})
export class ProcessoSeiService {
  private http = inject(HttpClient);
  private baseUri = environment.api.uri.concat('sei');

  /** Todas as notificações com número SEI no processo (Bot SisNot ↔ SEI). */
  processos(): Observable<ProcessoSei[]> {
    return this.http.get<ProcessoSei[]>(`${this.baseUri}/processos`);
  }

  /** Bot: grava a Localização (unidades do SEI) das notificações; registra no histórico. */
  atualizarLocalizacoes(itens: {id: number; localizacao: string}[]): Observable<{atualizadas: number}> {
    return this.http.put<{atualizadas: number}>(`${this.baseUri}/localizacao`, itens);
  }

  /** Notificações deste processo do SEI ("Abrir no SisNot" do SEI). */
  porNumero(numero: string): Observable<ProcessoSei[]> {
    return this.http.get<ProcessoSei[]>(`${this.baseUri}/notificacoes`, {params: {numero}});
  }
}
